/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Output,
} from '@angular/core';

@Component({
  standalone: false,
  moduleId: module.id ? String(module.id) : undefined,
  selector: 'gh-autocomplete-action-icon',
  template: `
    <mat-icon
      svgIcon="gh:arrow-drop-down"
      *ngIf="display && !disabled"
      class="s20 gh-autocomplete-clear-icon"></mat-icon>`,
  styleUrls: ['autocomplete-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AutocompleteArrowIconComponent {
  @Output() trigger: EventEmitter<any> = new EventEmitter();

  disabled: boolean = false;
  display: boolean = true;

  constructor(public _element: ElementRef,
              private changeDetectorRef: ChangeDetectorRef) {
  }

  @HostListener('click', ['$event'])
  handleClick($event: any): void {
    if (this._element.nativeElement.parentElement.firstElementChild.disabled) {
      return;
    }

    $event.stopPropagation();
    $event.preventDefault();
    this.trigger.emit($event);
    this.changeDetectorRef.markForCheck();
  }

  setDisplay(isDisplay: boolean): void {
    this.display = isDisplay;
    this.changeDetectorRef.markForCheck();
  }

  setDisabled(isDisabled: boolean): void {
    this.disabled = isDisabled;
    this.changeDetectorRef.markForCheck();
  }

}
